// @flow strict
import { Button, Card, Divider, Modal, message } from "antd";
import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { cancelSubscription } from "../../api/pricing";

function ActivePlan({ plan, remaining }) {
  const navigate = useNavigate();

  const handleClickCancel = () => {
    Modal.confirm({
      title: 'Cancel Subscription Plan',
      content: <p className="mb-3">{`Are you sure you want to cancel your subscription plan? Please be aware that once you cancel, you will not be eligible for a refund.`}</p>,
      okText: "Cancel Now",
      cancelText: 'Cancel',
      onOk: handleCancelSubscription,
      okType: "danger",
    });
  };

  const handleCancelSubscription = async () => {
    try {
      const res = await cancelSubscription();

      message.success(res.data.message);
      navigate(0);
    } catch (error) {
      message.error(error.message);
      console.log(error)
    }
  };

  return (
    <Card className="active-pricing-card">
      <p className="popular-badge">Current Plan</p>
      <div className="">
        <h3 className="pricing-title">{plan?.name}</h3>
        <p className="pricing-desc">{plan?.description}</p>
        <Divider />
        <div className="pricing-items">
          <p className="pricing-item">
            <FaCheckCircle className="pricing-icon" />
            <span>{`${plan?.token} chat tokens per month.`}</span>
          </p>
          <p className="pricing-item">
            <FaCheckCircle className="pricing-icon" />
            <span>
              <span>Access to using</span>
              <span className="text-capitalize">
                {`${plan?.chat_providers.map((provider) => " " + provider)}.`}
              </span>
            </span>
          </p>
          <p className="pricing-item">
            <FaCheckCircle className="pricing-icon" />
            <span>
              {`Max ${plan?.max_file} ${plan?.max_file > 1 ? "files" : "file"} upload per assistant.`}
            </span>
          </p>
          <p className="pricing-item">
            <FaCheckCircle className="pricing-icon" />
            <span> {`${plan?.user_count} users per organization.`}</span>
          </p>
          <p className="pricing-item">
            <FaCheckCircle className="pricing-icon" />
            <span> {`${plan?.assistant_limit} assistants per organization.`}</span>
          </p>
          <p className={plan?.advance_parameter ? "pricing-item" : "pricing-item muted"}>
            <FaCheckCircle className="pricing-icon" />
            <span> {`Access to advance parameter settings.`}</span>
          </p>
          <p className={plan?.customize_chat ? "pricing-item" : "pricing-item muted"}>
            <FaCheckCircle className="pricing-icon" />
            <span> {`Access to customize chat.`}</span>
          </p>
        </div>
      </div>

      <Divider />
      <div>
        {
          plan?.price_amount === 0 ?
            <>
              <p className="fs-5 font-text-bold text-primary">
                Free Forever
              </p>
              <p className="mt-0 text-success font-text-bold">
                No credit card required
              </p>
            </>
            :
            <>
              <p className="font-text-bold text-primary">
                <span className="fs-5">{`$${plan?.price_amount}`}</span>
                <span>{`/${plan?.interval}`}</span>
              </p>
              <p className="mt-0">Billed monthly</p>
            </>
        }
      </div>

      <div className="d-flex justify-content-between align-items-center mt-3 gap-2">
        <Button href="/pricing" size="large" className="w-100 text-decoration-none" type="primary">
          Update Plan
        </Button>
        {
          plan?.price_amount !== 0 &&
          <Button size="large" className="w-100" danger onClick={handleClickCancel} disabled={plan?.price_amount === 0}>
            Cancel Subscription
          </Button>
        }
      </div>
    </Card>
  );
};

export default ActivePlan;